<style lang="scss" scoped></style>

<template>
  <td>
    <div @click="copy()" class="btn btn-primary">Kopieren</div>
  </td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    computed: {
      url() {
        let domain = Laravel.domains[0];
        domain = domain.replace(/\/$/, "");

        return `${domain}/affiliate/public/${this.content}`;
      }
    },
    methods: {
      copy() {
        navigator.clipboard.writeText(this.url);
        this.$notify({
            title: "Link kopiert",
            type: "success"
        });
      }
    }
};
</script>
